import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _VIEW_TYPE_TO_NOTE_IT;
// Components
import DefaultNoteItem from './molecules/defaultNoteItem';
import CompactNoteItem from './molecules/compactNoteItem';
import { VIEW_TYPE } from '../constants/note.general';
export var VIEW_TYPE_TO_NOTE_ITEM_COMPONENT = (_VIEW_TYPE_TO_NOTE_IT = {}, _defineProperty(_VIEW_TYPE_TO_NOTE_IT, VIEW_TYPE.DEFAULT, DefaultNoteItem), _defineProperty(_VIEW_TYPE_TO_NOTE_IT, VIEW_TYPE.COMPACT, CompactNoteItem), _VIEW_TYPE_TO_NOTE_IT);